import actions from './actions';
import { ICheckoutState } from '../../../../interfaces';

const actionLogger = (type: string, payload: any) => `action => ${type}, ${payload}`;

const checkoutReducer = (
  state: ICheckoutState,
  action: any,
): ICheckoutState => {
  if (process.env.NODE_ENV === 'development') {
    console.info(actionLogger(action.type, action.payload));
  }

  const { type, payload } = action;

  switch (type) {
    case actions.UPDATE_FIELD: {
      const { name, value } = payload;
      if (name === 'shipCountry') {
        return {
          ...state,
          [name]: value,
          shipState: '',
        };
      }
      return {
        ...state,
        [name]: value,
      };
    }
    case actions.SET_PROSPECT_FIELD: {
      return {
        ...state,
        [payload.name]: payload.value,
      };
    }
    case actions.SET_PLANCODE: {
      return {
        ...state,
        planCode: payload,
      };
    }
    case actions.SET_BILLING_METHOD: {
      return {
        ...state,
        billingMethod: payload,
      };
    }
    case actions.SET_TOTAL: {
      return {
        ...state,
        total: payload,
      };
    }
    case actions.SET_LOADING: {
      return {
        ...state,
        loading: payload,
      };
    }
    case actions.ON_CAPTCHA_TOKEN_VERIFY: {
      return {
        ...state,
        hCaptchaToken: payload,
      };
    }
    case actions.ON_CAPTCHA_EXPIRED: {
      return {
        ...state,
        hCaptchaToken: null,
        loading: false,
      };
    }
    case actions.ON_CAPTCHA_ERROR: {
      return {
        ...state,
        hCaptchaToken: null,
        formError: payload,
        loading: false,
      };
    }
    case actions.ON_RECURLY_TOKEN_ERROR: {
      return {
        ...state,
        hCaptchaToken: null,
        recurlyError: payload,
        loading: false,
      };
    }
    case actions.ON_SUBMIT_ERROR: {
      return {
        ...state,
        hCaptchaToken: null,
        formError: payload,
        loading: false,
      };
    }
    case actions.ON_ALT_PAYMENT_CANCEL: {
      return {
        ...state,
        hCaptchaToken: null,
        loading: false,
      };
    }
    case actions.ON_ACCEPTED_TERMS: {
      return {
        ...state,
        acceptedTerms: payload,
      };
    }
    default:
      return state;
  }
};

export default checkoutReducer;
